module.exports = __webpack_public_path__ + "static/img/repro_logo.3a1fb66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/repro_logo.png
// module id = TlBe
// module chunks = 1